// Navbar Placeholder - uses the same navbar-type-1 structure as the full navbar
// This ensures zero CLS when transitioning from placeholder to full navbar

// Import the shared navbar layout styles.
@import '../../../../navbars/type-1/index';

// Hide element visually but keep accessible for screen readers and crawlers
@mixin visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

// The placeholder serves as the layout anchor during SSR and initial load.
// The full navbar renders as an invisible overlay on top of the placeholder,
// then fades in once fully styled. This prevents CLS and style flash.
sn-navbar-placeholder-type-1 {
  display: block;
  position: sticky;
  top: 0;
  z-index: 105;
}

.sn-navbar-placeholder {
  display: block;
  position: relative; // Anchor for the overlay navbar

  navbar-type-1.is-sticky-host {
    position: static;
    z-index: auto;
  }

  .navbar-type-1 {
    border-bottom: none;
    z-index: 103;
  }

  // Match the full navbar's container width/padding so swapping the placeholder
  // for the real sn-navbar-type-1 causes no horizontal shift. Base defaults are
  // max-width 1440px + 64px desktop padding; the real navbar uses
  // $navbar-max-width + md.
  .navbar-type-1__container {
    padding-right: var(--spacing-md);
    padding-left: var(--spacing-md);
    max-width: $navbar-max-width;
  }

  .navbar-type-1--logo-nav-first {
    .navbar-type-1__logo-column {
      margin-right: $spacing-xl;
    }

    .navbar-type-1__nav-column {
      gap: $spacing-md;

      @include below($breakpoint-desktop-md + 58px) {
        gap: $spacing-2xs;
      }
    }
  }

  // SEO links - hidden but crawlable
  &__seo-links {
    @include visually-hidden;
  }

  // Inline SVG logo styling to match me-logo component
  .me-logo {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    min-width: 92px;

    svg {
      display: block;
      height: auto;
      width: auto;
      max-height: 36px;

      @include desktop {
        max-height: 40px;
      }
    }
  }
}

// =============================================================================
// Mobile breakpoint override for SSR and pre-hydration (960px)
// =============================================================================
// The navbar-type-1 component uses mobileBreakpoint={960} but the CSS
// media queries only handle 768px (below-desktop). The JS-based
// is-mobile-view class only works after hydration.
// For SSR placeholder, we need CSS-only solution to match 960px breakpoint.
// NOTE: These styles must be at root level (not nested in .sn-navbar-placeholder)
// because Stencil compiles component styles by tag name, not class name.
// Main navbar has identical media query in its own stylesheet.
// =============================================================================
@media only screen and (width <= 960px) {
  // Target navbar inside placeholder specifically
  sn-navbar-placeholder-type-1 .navbar-type-1--logo-nav-first {
    .navbar-type-1__nav-column {
      display: none;
    }

    .navbar-type-1__actions-column {
      display: none;

      me-button[icon='interface--search'] {
        display: inline-flex !important;
      }
    }

    .navbar-type-1__mobile-toggle {
      display: flex;
      order: 3;
    }
  }
}

// Hidden state when real navbar is loaded
sn-navbar-placeholder-type-1[hidden] {
  display: none !important;
}
